export default "__VITE_ASSET__B0cGmWj3__"